import React, { Component } from 'react'
import { withRouter, Route } from 'react-router-dom'
import { connect } from 'react-redux'

import { isAuthenticated, login, logout } from 'store/actions/authAction'
import { appBodyClick } from 'store/actions/appAction'
import AuthContainer from 'modules/AuthContainer'
import PlayerContainer from 'modules/PlayerContainer'

import Menu from 'components/Menu'
import Settings from 'components/Settings'
import Overlay from 'components/Overlay'
import MessageOverlay from 'components/MessageOverlay'

import Container from 'ui/Container'

class App extends Component {

  constructor(props){
    super(props)
    this.state = {
      isAuthenticated:false
    }
  }

  componentDidMount(){
    this.props.dispatch(isAuthenticated())
  }

  login(data){
    this.props.dispatch(login(data.username,data.password))
  }

  logout(){
    this.props.dispatch(logout())
  }

  appClick(e){
    this.props.dispatch(appBodyClick())
  }

  render() {
    const { auth, saved, menu, settings } = this.props
    if(auth.isAuthenticated){
      return (
        <Container classname="app" height="100%" action={(e)=>this.appClick(e)}>
          <Route path="/" component={PlayerContainer} exact={true} />
          <Overlay/>
          <MessageOverlay/>
          <Menu isActive={menu.isActive}/>
          <Settings isActive={settings.isActive}/>
        </Container>
      )
    } else {
      return (
        <AuthContainer
          loading={auth.loading}
          message={auth.message}
          login={(data)=>this.login(data)}/>
      )
    }
  }
}

function mapStateToProps(store){
  return {
    auth:store.auth,
    saved:store.saved,
    menu:store.menu,
    settings:store.settings
  }
}
export default withRouter(connect(mapStateToProps)(App))



// WEBPACK FOOTER //
// ./src/App.js